import { ProgressBar } from 'react-bootstrap';
import { HeadingDescSmall, HeadingDescVsmall } from '../../Headings';
import infoIcon from '../../../assets/images/svg/info-gray-round.svg';
import './healthCheckResultCard.css';

function HealthCheckResultCard(props) {
  // eslint-disable-next-line operator-linebreak
  const { progress, bgColor, stages, icon, title, secondTitle, detail } = props;
  const progressInstance = (
    <ProgressBar now={progress} label={`${progress}%`} visuallyHidden />
  );
  return (
    <div className="healthCheckResultCard">
      <div className="headingRow">
        <div className="leftBox">
          <img src={icon} alt="icon" />
          <div className="title">
            <HeadingDescSmall text={title} />
          </div>
          <HeadingDescSmall text={secondTitle} />
        </div>
        <div className="rightBox">
          <img src={infoIcon} alt="infoIcon" />
        </div>
      </div>
      <div className="info">
        <HeadingDescVsmall text={detail} />
      </div>
      <div className={`progressBarContainer ${bgColor}`}>
        <div className="w-100">
          {progressInstance}
          <div className="progressBarLabelContainer">
            <HeadingDescVsmall text={stages && stages[0] ? stages[0] : 'Low'} />
            <HeadingDescVsmall
              text={stages && stages[1] ? stages[1] : 'Normal'}
            />
            <HeadingDescVsmall
              text={stages && stages[2] ? stages[2] : 'High'}
            />
          </div>
        </div>
        <div>
          <HeadingDescSmall text={progress} />
        </div>
      </div>
    </div>
  );
}

export default HealthCheckResultCard;
